'use client';

import React from 'react';
import {Box, Typography, styled} from '@mui/material';

export const StyledStatisticsSectionContainer = styled(Box)(({theme}) => ({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  backgroundImage: 'url(/images/statistics-background.svg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: theme.shape.borderRadiusLg,
  margin: theme.spacing(2, 0, 4, 0),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(1, 0, 2, 0),
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0, 0, 0, 0),
  },
}));

export const StyledStatisticsSectionContent = styled(Box)(({theme}) => ({
  position: 'relative',
  zIndex: 1,
  padding: theme.spacing( 3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(5, 3),
  },
}));

export const StyledStatisticsGrid = styled(Box)(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: theme.spacing(4),
  marginTop: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
    gap: theme.spacing(3),
  },
}));

export const StyledCountUpValue = styled('span')(({ theme }) => ({
  fontSize: theme.typography.h3.fontSize,
}));

export const StyledStatisticsItem = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  textAlign: 'center',
  color: theme.palette.common.white,
  borderRight: '2px solid rgba(255, 255, 255, 0.8)',
  paddingRight: theme.spacing(4),
  '&:last-child': {
    borderRight: 'none',
    paddingRight: 0,
  },
  [theme.breakpoints.down('md')]: {
    borderRight: 'none',
    paddingRight: 0,
    borderBottom: '1px solid rgba(255, 255, 255, 0.8)',
    paddingBottom: theme.spacing(3),
    '&:last-child': {
      borderBottom: 'none',
      paddingBottom: 0,
    },
  },
}));

export const StyledStatisticsItemRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}));

export const StyledStatisticsHeading = styled(Typography)(({theme}) => ({
  color: theme.palette.common.white,
}));

export const StyledStatisticsNumberUnit = styled(Typography)<{component?: React.ElementType}>(({theme}) => ({
  color: theme.palette.common.white,
  fontWeight: 700,
}));

export const StyledStatisticsDescription = styled(Typography)(({theme}) => ({
  color: theme.palette.common.white,
  marginTop: theme.spacing(-1),
  textAlign: 'left',
}));
